import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-play",
  "use": "n-icon-play-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"n-icon-play\">\n    <path d=\"M14.7258 9.10247C15.4099 9.5053 15.4099 10.4948 14.7258 10.8976L7.40359 15.2097C6.70918 15.6186 5.83333 15.118 5.83333 14.3121V5.68803C5.83333 4.88215 6.70918 4.3815 7.40358 4.79044L14.7258 9.10247Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol